import { DatePicker } from "antd";
import moment from "moment-timezone";

import { DateTimeRangeFilterValue } from "./FilterBarDateTimeRangeTypes";
import { FILTER_VALUE_DATE_FORMAT } from "./FilterBarDateTimeRangeUtils";
const { RangePicker } = DatePicker;

interface FilterBarDateTimeRangeProps {
    facetedValues?: Map<string, number>;
    filterValue: DateTimeRangeFilterValue;
    setFilterValue: (value: DateTimeRangeFilterValue) => void;
    allowEmpty?: [boolean, boolean];
}
export function FilterBarDateTimeRange({
    facetedValues,
    filterValue,
    setFilterValue,
    allowEmpty = [true, true],
}: FilterBarDateTimeRangeProps) {
    const nonEmptyValues = facetedValues
        ? [...facetedValues.keys()].filter((key) => key !== "")
        : [];
    const sortedMoments = nonEmptyValues
        .map((date) => moment(date))
        .sort((a, b) => a.valueOf() - b.valueOf());
    const minMoment = sortedMoments[0]?.clone().startOf("day");
    const maxMoment = sortedMoments[sortedMoments.length - 1]
        ?.clone()
        .endOf("day");
    const value: [moment.Moment | null, moment.Moment | null] = [
        filterValue?.[0]
            ? moment(filterValue[0], FILTER_VALUE_DATE_FORMAT)
            : null,
        filterValue?.[1]
            ? moment(filterValue[1], FILTER_VALUE_DATE_FORMAT)
            : null,
    ];
    const handleChange = (
        value: [moment.Moment | null, moment.Moment | null] | null
    ) => {
        if (!value) {
            setFilterValue(null);
            return;
        }
        const convertedValue: DateTimeRangeFilterValue = [
            value[0] ? value[0].format(FILTER_VALUE_DATE_FORMAT) : null,
            value[1] ? value[1].format(FILTER_VALUE_DATE_FORMAT) : null,
        ];
        setFilterValue(convertedValue);
    };
    return (
        <RangePicker
            format="DD-MM-YYYY"
            onChange={(value) => handleChange(value)}
            value={value}
            defaultPickerValue={[minMoment, maxMoment]}
            disabledDate={(current) => {
                if (!minMoment || !maxMoment) {
                    return false;
                }
                return (
                    current.isBefore(minMoment) || current.isAfter(maxMoment)
                );
            }}
            disabled={facetedValues ? nonEmptyValues.length === 0 : false}
            allowEmpty={allowEmpty}
            showNow
            autoFocus
        />
    );
}
